import { render, staticRenderFns } from "./Presences.vue?vue&type=template&id=f128f046&scoped=true&"
import script from "./Presences.vue?vue&type=script&lang=js&"
export * from "./Presences.vue?vue&type=script&lang=js&"
import style0 from "./Presences.vue?vue&type=style&index=0&id=f128f046&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f128f046",
  null
  
)

export default component.exports